import { Encoder, Decoder } from '@msgpack/msgpack';

import { base32EncodeBinary } from './base32';
import { base64DecodeBinaryURL, base64EncodeBinaryURL } from './base64';

const encoder = new Encoder();
const decoder = new Decoder();

/**
 * Turns the given JWT into a compact binary representation, by decoding it and then
 * re-encoding it using MessagePack.
 *
 * @param jwt The JWT token to encode.
 */
export function jwtToBinary(jwt: string) {
  const parts = jwt.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid JWT');
  }

  const partsBinary = parts.map((part) => base64DecodeBinaryURL(part));
  return encoder.encode(partsBinary);
}

/**
 * Converts a MessagePack-encoded JWT (@see jwtToBinary) back into a JWT string.
 *
 * @param binary The binary encoding of the JWT.
 */
export function binaryToJwt(binary: Uint8Array) {
  const partsBinary = decoder.decode(binary) as Uint8Array[];
  if (partsBinary.length !== 3) {
    throw new Error('Invalid JWT');
  }

  const parts = partsBinary.map((part) => base64EncodeBinaryURL(part));

  return parts.join('.');
}

/**
 * Encodes a JWT token for authentication over the Sec-WebSocket-Protocol header.
 *
 * @param jwt The JWT token to encode.
 * @returns The Sec-WebSocket-Protocol header encoding the token.
 */
export function encodeTokenForWebSocket(jwt: string) {
  return base32EncodeBinary(
    encoder.encode({
      access_token: jwtToBinary(jwt),
    }),
    '0',
  );
}
